/*
 * This code is protected by intellectual property rights.
 * Dr. Ing. h.c. F. Porsche AG owns exclusive rights of use.
 * © 2017-2026, Dr. Ing. h.c. F. Porsche AG.
 */

import { Component, EventEmitter, Input, Output, QueryList, ChangeDetectionStrategy } from '@angular/core'
import { UntypedFormGroup } from '@angular/forms'
import { DynamicFormGroupModel } from '../model/form-group/dynamic-form-group.model'
import { DynamicFormControlLayout } from '../model/misc/dynamic-form-control-layout.model'
import { DynamicFormLayout } from '../service/dynamic-form-layout.service'
import { DynamicFormControlContainerComponent } from './dynamic-form-control-container.component'
import { BaseFormControlComponent } from './form-controls/base-form-control.component'

@Component({
  selector: 'dynamic-form-group',
  templateUrl: './dynamic-form-group.component.html',
  standalone: false,
  styles: [
    `
      /* Neutralise default <fieldset> chrome so the semantic grouping (WCAG 1.3.1)
         does not introduce a visual regression in existing form layouts. */
      .dynamic-form-group__fieldset {
        border: 0;
        margin: 0;
        padding: 0;
        min-width: 0;
      }
      .dynamic-form-group__legend {
        display: contents;
      }
    `,
  ],
  // Angular 22 changed the implicit default to OnPush (see angular/angular#67687). This component was never migrated
  // to OnPush semantics, so Eager restores the pre-v22 behaviour it relies on.
  // eslint-disable-next-line @angular-eslint/prefer-on-push-component-change-detection
  changeDetection: ChangeDetectionStrategy.Eager,
})
export class DynamicFormGroupComponent extends BaseFormControlComponent {
  // @ts-ignore
  @Input() formLayout: DynamicFormLayout
  // @ts-ignore
  @Input() group: UntypedFormGroup
  // @ts-ignore
  @Input() layout: DynamicFormControlLayout
  // @ts-ignore
  @Input() model: DynamicFormGroupModel

  // eslint-disable-next-line @angular-eslint/no-output-native
  @Output() blur: EventEmitter<any> = new EventEmitter()
  // eslint-disable-next-line @angular-eslint/no-output-native
  @Output() change: EventEmitter<any> = new EventEmitter()
  // eslint-disable-next-line @angular-eslint/no-output-native
  @Output() focus: EventEmitter<any> = new EventEmitter()
  @Output() metaDataSelectedEvent: EventEmitter<any> = new EventEmitter()

  components!: QueryList<DynamicFormControlContainerComponent>

  markForCheck() {
    if (this.components instanceof QueryList) {
      this.components.forEach((component) => component.markForCheck())
    }
  }

  public metaDataSelected($event: any) {
    this.metaDataSelectedEvent.emit($event)
  }
}
